var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfastrService(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 246,
    viewBox: "0 0 330 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9999 128.5C-3.50011 166.5 5.00006 213.5 87 201C169 188.5 190 242.5 278 245.5C324.469 247.084 324.912 222 317.5 195C310.088 168 321.96 139.148 325.5 108C333 42 249 36 216 60C183 84 165.125 88.9564 137 71C71.9999 29.5 13.4999 90.5001 4.9999 128.5Z",
    fill: "#EFF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.631 232C263.466 232 299 227.183 299 221.241C299 215.299 263.466 210.482 219.631 210.482C175.797 210.482 140.263 215.299 140.263 221.241C140.263 227.183 175.797 232 219.631 232Z",
    fill: "#3D4456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.159 123.716C121.844 122.654 156.215 137.517 128.209 177.858C100.204 218.199 139.348 222.976 170.111 194.844",
    stroke: "#2E3441",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203.391 194.062L201.182 208.117C201.182 208.117 190.306 213.874 197.953 214.044C205.601 214.213 241.629 214.044 241.629 214.044C241.629 214.044 248.597 214.044 237.551 207.947L235.341 193.215L203.391 194.062Z",
    fill: "#2E3441"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M196.415 213.891C198.152 212.351 201.183 210.747 201.183 210.747L203.392 196.692L235.342 196.722L237.551 210.577C240.127 211.999 241.723 213.089 242.656 213.925C244.075 213.602 245.625 212.403 237.551 207.947L235.342 193.215L203.392 194.062L201.183 208.117C201.183 208.117 192.043 212.955 196.415 213.891Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M286.108 96.0996H152.285C149.49 96.0996 147.224 98.3574 147.224 101.142V190.966C147.224 193.751 149.49 196.009 152.285 196.009H286.108C288.903 196.009 291.169 193.751 291.169 190.966V101.142C291.169 98.3574 288.903 96.0996 286.108 96.0996Z",
    fill: "#2E3441"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M286.325 101.434H152.068V176.281H286.325V101.434Z",
    fill: "#3D4456"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M219.196 99.9098C219.666 99.9098 220.046 99.5307 220.046 99.0631C220.046 98.5954 219.666 98.2164 219.196 98.2164C218.727 98.2164 218.347 98.5954 218.347 99.0631C218.347 99.5307 218.727 99.9098 219.196 99.9098Z",
    fill: "#F4F8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M291.169 182.208V190.966C291.169 191.628 291.038 192.284 290.784 192.896C290.529 193.508 290.157 194.064 289.687 194.532C289.217 195 288.659 195.372 288.045 195.625C287.431 195.879 286.772 196.009 286.108 196.009H152.285C151.621 196.009 150.963 195.879 150.349 195.625C149.734 195.372 149.176 195 148.707 194.532C148.237 194.064 147.864 193.508 147.609 192.896C147.355 192.284 147.224 191.628 147.224 190.966V182.208H291.169Z",
    fill: "#2E3441"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256.754 223.188V224.881H165.323V223.526L165.449 223.188L167.703 217.092H254.885L256.754 223.188Z",
    fill: "#2E3441"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M291.94 221.53C291.774 222.239 291.145 222.988 289.724 223.696C284.626 226.236 274.259 223.018 274.259 223.018C274.259 223.018 266.272 221.664 266.272 218.108C266.496 217.955 266.73 217.816 266.972 217.693C269.115 216.563 276.223 213.775 288.824 217.811C289.753 218.101 290.582 218.643 291.22 219.375C291.73 219.971 292.131 220.726 291.94 221.53Z",
    fill: "#2E3441"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M291.941 221.53C285.7 223.913 280.138 224.09 274.429 220.14C271.551 218.148 268.935 217.656 266.972 217.693C269.116 216.563 276.223 213.775 288.825 217.811C289.753 218.101 290.582 218.643 291.22 219.375C291.731 219.971 292.131 220.726 291.941 221.53Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M284.116 220.14C285.336 220.14 286.325 219.837 286.325 219.462C286.325 219.088 285.336 218.785 284.116 218.785C282.896 218.785 281.907 219.088 281.907 219.462C281.907 219.837 282.896 220.14 284.116 220.14Z",
    fill: "#F4F8FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.197 192.368C220.98 192.368 222.426 190.928 222.426 189.151C222.426 187.374 220.98 185.933 219.197 185.933C217.413 185.933 215.968 187.374 215.968 189.151C215.968 190.928 217.413 192.368 219.197 192.368Z",
    fill: "#F4F8FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M256.754 223.188V224.881H165.323V223.526L165.449 223.188H256.754Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.741 89.5891H49.406V157.216H107.741V89.5891Z",
    fill: "#2E3441"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.946 59.4482C18.946 81.1051 32.5812 98.6296 49.4317 98.6296L18.946 59.4482Z",
    fill: "#2E3441"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4319 98.6295C49.4319 76.7293 64.648 59.0079 83.4521 59.0079L49.4319 98.6295Z",
    fill: "#478DFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9919 61.4114C29.9919 81.9832 38.6868 98.6295 49.4321 98.6295L29.9919 61.4114Z",
    fill: "#478DFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4319 98.6296C49.4319 70.6459 67.0193 48.002 88.754 48.002L49.4319 98.6296Z",
    fill: "#2E3441"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6472 170.893C103.612 170.893 127.092 167.71 127.092 163.784C127.092 159.857 103.612 156.674 74.6472 156.674C45.6826 156.674 22.2021 159.857 22.2021 163.784C22.2021 167.71 45.6826 170.893 74.6472 170.893Z",
    fill: "#3D4456"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.6469 169.752C98.9648 169.752 118.678 167.08 118.678 163.784C118.678 160.487 98.9648 157.815 74.6469 157.815C50.329 157.815 30.6155 160.487 30.6155 163.784C30.6155 167.08 50.329 169.752 74.6469 169.752Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.63 82.8823H43.5166V106.915H113.63V82.8823Z",
    fill: "#3D4456"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.63 111.386H43.5166V135.419H113.63V111.386Z",
    fill: "#3D4456"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.63 139.89H43.5166V163.923H113.63V139.89Z",
    fill: "#3D4456"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.6076 87.0741H95.1204V91.5453H99.6076V87.0741Z",
    fill: "#478DFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M106.058 87.0741H101.571V91.5453H106.058V87.0741Z",
    fill: "#478DFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.508 87.0741H108.021V91.5453H112.508V87.0741Z",
    fill: "#478DFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.6076 115.299H95.1204V119.77H99.6076V115.299Z",
    fill: "#478DFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M106.058 115.299H101.571V119.77H106.058V115.299Z",
    fill: "#478DFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M112.508 115.299H108.021V119.77H112.508V115.299Z",
    fill: "#478DFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.6076 143.523H95.1204V147.994H99.6076V143.523Z",
    fill: "#478DFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M106.058 143.523H101.571V147.994H106.058V143.523Z",
    fill: "#478DFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.508 143.523H108.021V147.994H112.508V143.523Z",
    fill: "#478DFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 199.855,
    cy: 47.855,
    r: 9.855,
    fill: "#EFF5FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.875,
    cy: 31.875,
    r: 5.875,
    fill: "#EFF5FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfastrService);
export default __webpack_public_path__ + "static/media/infastr_service.5c18e8e07855b8207d4d182344c71246.svg";
export { ForwardRef as ReactComponent };